import { cn } from "@/libraries/cn";
import Button from "@mui/material/Button";
import type { SetOptional } from "type-fest";
import type { BasicButtonProps } from "./ButtonBasicButton";

interface ButtonFloatingSubmitProps
	extends SetOptional<BasicButtonProps, "variant" | "color"> {
	label: string;
}

const ButtonFloatingSubmit = (props: ButtonFloatingSubmitProps) => {
	const {
		label,
		disabled,
		className,
		variant = "contained",
		color = "primary",
	} = props;
	return (
		<div className="fixed bg-white shadow bottom-0 inset-x-0 z-10 py-3">
			<div className="wrapper">
				<div className="container">
					<Button
						variant={variant}
						color={color}
						disabled={disabled}
						className={cn(
							"w-full !h-12 text-sm font-semibold !shadow-none !rounded-full",
							className,
						)}
						{...props}
					>
						{label}
					</Button>
				</div>
			</div>
		</div>
	);
};

export default ButtonFloatingSubmit;
